import React, { useEffect, useState, useRef } from "react";
import {GET_All_POLICIES_URL} from "../../../api";
import {
  verifyPhoneNumber,
  uploadToRtsa,
  getInsuranceCompanies,
} from "../../../request";
import { gariCodes } from "../../../data/gariCodes";
import $ from "jquery";
import "components-jqueryui";
import "parsleyjs";
import "select2";
import "datatables.net";
import "datatables.net-responsive";
import moment from "moment";
import { encodeQueryParameter } from "../../../utils/url";

const Policy = (props) => {
  document.title = "Policy";


  useEffect(() => {

    var table = $("#policy").DataTable({
      responsive: true,
      language: {
        processing:
          '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Policies Data</p>',
      },
      searching: true,
      lengthMenu: [[10], [10]],
      ordering: false,
      info: true,
      bFilter: false,
      processing: true,
      pageLength: 10,
      serverSide: true,

      destroy: true,
      ajax: function (data, callback) {
        // make a regular ajax request using data.start and data.length
        $.ajax(`${GET_All_POLICIES_URL()}`, {
          type: "GET",
          data: {
            pageNumber: (data.length + data.start) / data.length,
            pageSize: data.length,
            query: data.search.value, 
          },
          success: function (res) {
            let result = [];

            res.data.map((data) => {
              result.push({
                raw: data,
              });
            });
            callback({
              recordsTotal: res.totalRecords,
              recordsFiltered: res.totalRecords,
              data: result,
            });
          },
        });
      },
      columns: [
        { data: "raw" },
        { data: "raw" },
        { data: "raw" },
        { data: "raw" },
        { data: "raw" },
        { data: "raw" },
      ],
      columnDefs: [
        {
          render: function (data) {
            return data.policyNumber;
          },
          targets: 0,
        },
        {
          render: function (data) {
            return `${data.client.firstName} ${
              data.client.middleName ? data.client.middleName : ""
            } ${data.client.lastName}`;
          },
          targets: 1,
        },
        {
          render: function (data) {
            return moment(data.startDate).add(1, "days").format("Do MMM, YYYY");
          },
          targets: 2,
        },
        {
          render: function (data) {
            return moment(data.endDate).format("Do MMM, YYYY");
          },
          targets: 3,
        },
        {
          render: function (data) {
            return moment(data.startDate).format("YYYY");
          },
          targets: 4,
        },
        {
          render: function (data) {
            return {
              Active: `<span class="badge badge-success tx-white">${data.status}</span>`,
              Expired: `<span class="badge badge-warning tx-white">${data.status}</span>`,
              Cancelled: `<span class="badge badge-danger">${data.status}</span>`,
              InClaim: `<span class="badge badge-warning">${data.status}</span>`,
              InReview: `<span class="badge badge-info">${data.status}</span>`,
              PayLater: `<span class="badge badge-secondary">${data.status}</span>`,
            }[data.status];
          },
          targets: 5,
        },
      ],
    });

    $("#policy tbody").on("click", "tr", function () {
      var extract_data = table.row(this).data();
      props.history.push(
        `/policy-details/${extract_data.raw.clientId}/${encodeQueryParameter(
          extract_data.raw.id
        )}`
      );
    });

    return () => {
      $("#date_from").datepicker("destroy");
    };
  }, []);

  $(function () {
    $("#date_from").datepicker({
      showOtherMonths: true,
      selectOtherMonths: true,
      minDate: "-120Y",
      maxDate: "-18Y",
      yearRange: "1800:+nn",
      changeMonth: true,
      changeYear: true,
      defaultDate: "+1w",
      numberOfMonths: 1,
      dateFormat: "yy/mm/dd",
    });

    $(function () {
      $("#policy_end_date").datepicker({
        showOtherMonths: true,
        selectOtherMonths: true,
        minDate: new Date().getDate(),
        yearRange: "1800:+nn",
        changeMonth: true,
        changeYear: true,
        defaultDate: "+1w",
        numberOfMonths: 1,
        dateFormat: "yy/mm/dd",
      });
    });
    $(function () {
      $("#policy_start_date").datepicker({
        showOtherMonths: true,
        selectOtherMonths: true,
        minDate: new Date().getDate(),
        yearRange: "1800:+nn",
        changeMonth: true,
        changeYear: true,
        defaultDate: "+1w",
        numberOfMonths: 1,
        dateFormat: "yy/mm/dd",
      });
    });

    $(".ad-select2").select2({
      minimumResultsForSearch: Infinity,
      placeholder: "Select",
    });

    $("#category_data").select2({
      placeholder: "Please select an skill",
      allowClear: true,
    });
  });


 
  

  return (
    <div className="content-body">
      <div className="container pd-x-0">
        <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                <li className="breadcrumb-item">
                  <a href="#">Menu</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Policy
                </li>
              </ol>
            </nav>

            <h4 className="mg-b-0 tx-spacing--1">Policy</h4>
          </div>

          <button
            data-toggle="modal"
            data-target="#modalManualRtsa"
            role="button"
            className="btn btn-sm btn-primary d-md-inline-block"
          >
            Manual Policy to RTSA
          </button>
        </div>

        <div className="row row-xs">
          <div className="col-md-12 mg-t-10">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-between">
                <h6 className="mg-b-0">Policy</h6>
                <div className="d-flex tx-18">
                  <a
                    href="javascript:void(0)"
                    onClick={() => $("#policy").DataTable().ajax.reload()}
                    className="link-03 lh-0"
                  >
                    <i className="icon ion-md-refresh"></i>
                  </a>
                </div>
              </div>
              <div className="card-body table-responsive">
                <table id="policy" className="table table-hover">
                  <thead className="thead-light">
                    <tr>
                      <th className="wd-20p">Policy #</th>
                      <th className="wd-20p">Client Name</th>
                      <th className="wd-15p">Start Date</th>
                      <th className="wd-15p">End Date</th>
                      <th className="wd-10p">U/W Year</th>
                      <th className="wd-10p">Status</th>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Policy;
